/**
 * Just modified version of useMemo that's executed only one time, at the mounting time.
 */
export const useMemoOnce = <T>(factory: () => T): T => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useMemo(factory, [])
}
